import Axios from './http-utils';

///"https://dtv-tpo-api.dps.gw01.aks01.eus.nonprod.azure.intra.pepsico.com";
// "https://dtv-tpo-api-qa.dps.gw01.aks01.eus.nonprod.azure.intra.pepsico.com/";//qa
export const API_ENDPOINT = window.REACT_APP_API_URL;

const AxiosClass = Axios;
const AxiosInstance = new AxiosClass(API_ENDPOINT);

export default AxiosInstance;
